import { render, staticRenderFns } from "./batchRenew.vue?vue&type=template&id=db9f6dec&scoped=true"
import script from "./batchRenew.vue?vue&type=script&lang=js"
export * from "./batchRenew.vue?vue&type=script&lang=js"
import style0 from "./batchRenew.vue?vue&type=style&index=0&id=db9f6dec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9f6dec",
  null
  
)

export default component.exports